import React from 'react';
import {
  Anchor, Axe, Bird, Bomb, Bot, Brain, Cat, Crosshair, Crown, Dog, Drama, Feather,
  Flame, Ghost, Gem, Hexagon, Rocket, Shield, Skull, Snowflake, Sparkles, Star,
  Swords, Target, Trophy, Wand, Waves, Zap, type LucideIcon
} from 'lucide-react';

// Curated, brand-safe icon library players pick from — game-flavored, no
// uploads. Slugs are stable identities stored on the user.
export const PROFILE_ICONS: Record<string, LucideIcon> = {
  swords: Swords,
  crosshair: Crosshair,
  target: Target,
  shield: Shield,
  skull: Skull,
  flame: Flame,
  zap: Zap,
  bomb: Bomb,
  rocket: Rocket,
  crown: Crown,
  trophy: Trophy,
  star: Star,
  gem: Gem,
  sparkles: Sparkles,
  ghost: Ghost,
  bot: Bot,
  brain: Brain,
  wand: Wand,
  axe: Axe,
  anchor: Anchor,
  waves: Waves,
  snowflake: Snowflake,
  feather: Feather,
  bird: Bird,
  cat: Cat,
  dog: Dog,
  drama: Drama,
  hexagon: Hexagon
};

export const ICON_SLUGS = Object.keys(PROFILE_ICONS);

export const AVATAR_COLORS = [
  '#A0C3AC', '#8EA7FF', '#E4B363', '#F97066', '#C9A0DC',
  '#6FCF97', '#56CCF2', '#F2994A', '#EB5757', '#BB6BD9'
];

export function iconFor(slug: string | null | undefined): LucideIcon | null {
  return slug ? PROFILE_ICONS[slug] ?? null : null;
}

export function renderIcon(slug: string | null | undefined, size: number): React.ReactNode {
  const Icon = iconFor(slug);
  return Icon ? React.createElement(Icon, { size }) : null;
}
